import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetTabellaComponent } from './widget-tabella.component';



@NgModule({
  declarations: [WidgetTabellaComponent],
  imports: [
    CommonModule
  ],
  exports:[WidgetTabellaComponent]
})
export class WidgetTabellaModule { }
